import React from 'react';
import Text from '../Text';
import { cn } from '../../utils/utils';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../ViewReverse';

const Tabs = ({ value, options, onClick, getContent, className }) => {
  return (
    <ViewReverse className='flex overflow-auto'>
      {options?.map((option, index) => (
        <div
          key={index}
          className={cn('py-2.5 min-w-28 border-b-2 cursor-pointer', value === option?.id ? 'border-b-light-blue' : 'border-b-dark-grey/50', className)}
          onClick={() => value !== option?.id && onClick(option)}
        >
          <Text text={getContent(option?.key)} isCenter color={value === option?.id ? 'text-light-blue' : 'text-dark-grey/50'} size={fontSizes.h14} />
        </div>
      ))}
    </ViewReverse>
  );
};

export default Tabs;
